(function ($) {
	'use strict';

	var banner = new App.Banner('.slider', {
		controls: false
	});

	banner.init();

	/**
	 * [onSlideBefore description]
	 * @param  {[type]} e        [description]
	 * @param  {[type]} previous [description]
	 * @param  {[type]} current  [description]
	 * @return {[type]}          [description]
	 */
	banner.onSlideBefore = function (e, previous, current) {
		if (previous > current) {
			e.find('.caption').css({
				//bottom: '-30%',
				opacity: 0
			});
		} else {
			e.find('.caption').css({
				//bottom: '70%',
				opacity: 0
			});
		}
	};
	/**
	 * [onSlideAfter description]
	 * @param  {[type]} e        [description]
	 * @param  {[type]} previous [description]
	 * @param  {[type]} current  [description]
	 * @return {[type]}          [description]
	 */
	banner.onSlideAfter = function (e, previous, current) {
		e.find('.caption').animate({
			//bottom: '15%'
		}, {
			queue: 'first',
			duration: 300
		}).dequeue('first');
		e.find('.caption').animate({
			opacity: 1
		}, {
			queue: 'second',
			duration: 500
		}).dequeue('second');
	};

	/* 
	 * Mostra o banner depois de carregar
	 */
	$(window).load(function () {
		$('.slider').animate({
			'opacity': 1
		});
	});

	/*
	 * Ao redimensionar a tela o banner também será redimensionado
	 */
	$(window).resize(function () {
		if (!App.isMobile.any()) {
			banner.boxResize();
		}
	});

	/*
	 * Ao mudar a orientação de um dispositivo movel para retrato ou paisagem o banner será redimencionado.
	 */
	window.addEventListener('orientationchange', function () {
		setTimeout(function () {
			banner.boxResize();
		}, 200);
	}, false);

}(jQuery));